import { getAuthTokenParsed } from '@sxm-de/dev-kits/web-sdk/utils';
import { AccountDomainInitPayload } from '../types/domain';

export type DeleteFn = () => Promise<void>;

export function initDeleteFn({
    dependencies,
    clientSdkBaseUrl,
}: AccountDomainInitPayload): DeleteFn {
    const { clientSdk, clientSdkStorageProvider } = dependencies;
    return async () => {
        try {
            /**
             * TODO:
             * Change this to call delete from ClientSdk when we update ClientSdk version.
             */
            const authToken = JSON.parse(
                (clientSdkStorageProvider?.getItem('AUTH_TOKEN') as
                    | string
                    | null) ?? '',
            );
            const authTokenParsed = getAuthTokenParsed(authToken);
            const accessToken = authTokenParsed?.session?.accessToken || '';
            await deleteUserIdentity(clientSdkBaseUrl, accessToken);
            await clientSdk.user.anonymousLogin(true);
        } catch (error: any) {
            /**
             * TODO:
             * Log error to error logger (not analytics).
             */
            throw new Error('SYSTEM');
        }
    };
}
async function deleteUserIdentity(baseHref: string, accessToken: string) {
    const response = await fetch(`${baseHref}/orchestration/v1/identities`, {
        method: 'DELETE',
        headers: {
            Accept: 'application/json; charset=utf-8',
            Authorization: 'Bearer {accessToken}'.replace(
                '{accessToken}',
                accessToken,
            ),
            'Content-Type': 'application/json',
        },
    });
    if (!response.ok) return Promise.reject(await response.json());
    return {};
}
